import React, { useRef } from 'react';
import { BASE_URL } from '@/constants/common';

interface Props {
  html: string;
  contentLoadedCallback?: () => void;
}

const HtmlViewer = ({ html, contentLoadedCallback }: Props) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);

  if (!html) {
    return null;
  }

  const resizeIframe = () => {
    const iframeDocument = iframeRef.current?.contentDocument;
    if (!iframeDocument) return;

    const contentHeight = iframeDocument.body.scrollHeight;
    iframeRef.current.style.height = `${contentHeight}px`;
    contentLoadedCallback?.();
  };

  const trackAllImageLoad = () => {
    const iframeDocument = iframeRef.current?.contentDocument;
    if (!iframeDocument) return;
    const imgElements = iframeDocument.querySelectorAll('img');

    const trackImageLoad = () => {
      let allImagesLoaded = true;

      imgElements.forEach((imgElement) => {
        if (!imgElement.complete) {
          allImagesLoaded = false;
        }
      });

      if (allImagesLoaded) {
        resizeIframe();
      } else {
        setTimeout(trackImageLoad, 100);
      }
    };

    trackImageLoad();
  };

  const onLoad: React.ReactEventHandler<HTMLIFrameElement> = (e) => {
    const iframeDocument = (e.target as HTMLIFrameElement).contentDocument;
    const linkElement = document.createElement('link');
    linkElement.rel = 'stylesheet';
    linkElement.href = `${BASE_URL}/css/htmleditor.css?v=20180327`;
    linkElement.onload = trackAllImageLoad;
    const headElement = iframeDocument?.querySelector('head');
    headElement?.appendChild(linkElement);
  };

  return (
    <iframe
      frameBorder="0"
      scrolling="no"
      style={{ width: '100%', height: '0' }}
      ref={iframeRef}
      srcDoc={`<div class="_htmlcontent">${html}</div>`}
      onLoad={onLoad}
    />
  );
};

export default HtmlViewer;
